import { Component } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { WsBlogService } from 'src/app/ws/wsBlog/ws-blog.service';
import { MCategoryResponseModal } from '../blog/blog.module';
import { MCommonListModalRequest } from 'src/app/utils/utils.service';
import { WsFoytvService } from 'src/app/ws/wsFoyTv/ws-foytv.service';
import { MtvChannelResponse } from './foy-tv.module';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-foy-tv',
  templateUrl: './foy-tv.component.html',
  styleUrls: ['./foy-tv.component.scss']
})
export class FoyTvComponent {
  mCategoryResponseModal: MCategoryResponseModal = new MCategoryResponseModal()
  mCommonListModalRequest: MCommonListModalRequest = new MCommonListModalRequest()
  mtvChannelResponse: MtvChannelResponse = new MtvChannelResponse()
  videoId: any = '';
  count: number = 0;
  count1: number = 0;
  videoUrlId = 'yyFrjG5os80'
  showImage: boolean = true;
  showImage1: boolean = true;
  videoLarge: any;
  categoryId: any;
  categorySelected: any = null;
  constructor(private wsblogservice: WsBlogService, private wsFoyTvService: WsFoytvService, private sanitizer: DomSanitizer) {

  }

  ngOnInit() {
    this.getCategoryList()
    this.getFoyTvAll()
  }

  /**
 * to get category list
 */
  async getCategoryList() {
    const categoryListData = this.wsblogservice.getCategoryByType(3);
    await lastValueFrom(categoryListData).then(response => {
      if (response && response.statusCode == 200) {
        this.mCategoryResponseModal.data = response.data;
      } else {
      }
    })
  }

  /**
  * to get foytv list
  */
  async getFoyTvAll() {
    this.mCommonListModalRequest.take = 10;
    if (this.mCommonListModalRequest.skip == 0) {
      this.mtvChannelResponse.data = []
    }
    const getFoyAll = this.wsFoyTvService.getFoyAll(this.mCommonListModalRequest);
    await lastValueFrom(getFoyAll).then(response => {
      if (response && response.statusCode == 200) {
        if (this.mtvChannelResponse.data.length < 1) {
          this.mtvChannelResponse.data = response.data;
        } else {
          this.mtvChannelResponse.data = [...this.mtvChannelResponse.data, ...response.data];
        }
        this.mtvChannelResponse.data.forEach((element: any) => {
          element.showImage = true;
        });
      } else {
      }
    })
  }

  async onScroll() {
    this.mCommonListModalRequest.skip = this.mtvChannelResponse.data.length;
    this.getFoyTvAll()
  }

  getImage(val: any, index?: any) {
    if (index == true) {
      return 'http://img.youtube.com/vi/' + val + '/hqdefault.jpg'
    }
    return 'http://img.youtube.com/vi/' + val.split('?v=')[1] + '/hqdefault.jpg'
  }

  getMobileImage(val: any, index?: any) {
    if (index == true) {
      return 'http://img.youtube.com/vi/' + val + '/hqdefault.jpg'
    }
    return 'http://img.youtube.com/vi/' + val.split('?v=')[1] + '/hqdefault.jpg'
  }

  previewVideo(i?: any) {
    this.count = 0;
    this.mtvChannelResponse.data.forEach((element: any, j: any) => {
      if (i == j) {
        this.mtvChannelResponse.data[j].showImage = false;
        this.showImage = true;
        this.showImage1 = true;
      } else {
        this.mtvChannelResponse.data[j].showImage = true;
      }
    });
  }

  showVideo(val: any, i: any) {
    if (this.count == 0) {
      this.mtvChannelResponse.data[i].sanitizeUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + val.split('?v=')[1] + '?autoplay=1');
      this.count = 1;
      return this.mtvChannelResponse.data[i].sanitizeUrl;
    }
  }

  showLargeVideo(val: any) {
    this.previewVideo();
    this.showImage = false;
  }
  showMobileLargeVideo(val: any) {
    this.previewVideo();
    this.showImage1 = false;
    
  }

  showLargeVideoView(val: any) {
    this.videoLarge = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + val + '?autoplay=1');
    this.count = 1
    this.previewVideo();
    this.showImage = false;
    this.showImage1 = true;
  }
  showMobileLargeVideoView(val: any) {
    this.videoLarge = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + val + '?autoplay=1');
    this.count = 1
    this.previewVideo();
    this.showImage1 = false;
    this.showImage = true;
  }

  setCategory(cat: any) {
    if (this.categoryId == cat.id) {
      this.categoryId = ''
      this.categorySelected = null
    } else {
      this.categoryId = cat.id
      this.categorySelected = cat
    }
    this.mCommonListModalRequest.category_id = this.categoryId;
    this.mCommonListModalRequest.skip = 0
    this.getFoyTvAll();
  }

}
